import { asyncRoutes, constantRoutes } from '@/router-v2'
import cloneDeep from 'lodash/cloneDeep'
import _path from 'path'

// 侧边栏禁止点击
export function sidebarDisabled(rootState) {
  let demoType = rootState.user.demoType
  let expiredTrialAccount = rootState.user.expiredTrialAccount
  let expiredDemoAccount = rootState.user.expiredDemoAccount
  
  // trial账号过期后禁止手动跳转侧边栏路由
  if (demoType === 'trial' && expiredTrialAccount) return true

  // beta账号过期且未延长15天的禁止手动跳转侧边栏路由
  if (demoType === 'demo' && expiredDemoAccount) return true

  // beta延长15天后再过期的禁止手动跳转侧边栏路由
  if (demoType === 'demo_trail' && expiredTrialAccount) return true
  return false
}

function hasPermission(role, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(role)
  } else {
    return true
  }
}

export function  filterAsyncRoutes(routes, rootState, isFully=false, basePath) {
  const res = []
  let role = rootState.user.role
  let demoType = rootState.user.demoType
  let expiredTrialAccount = rootState.user.expiredTrialAccount
  let expiredDemoAccount = rootState.user.expiredDemoAccount
  routes.forEach(route => {
    if (typeof route === "function") {
      route = route(role)
    }
    // trial账号过期后禁止手动跳转侧边栏路由
    const tmp = { ...route, disabled: sidebarDisabled(rootState) }
    let path = basePath ? _path.resolve(basePath, tmp.path) : tmp.path
    // 过滤特殊条件下的路由
    if (!isFully) {
      // 当用户是trial,且账户过期后才允许进入reactive页面,其他不可进入
      if (!(demoType === 'trial' && expiredTrialAccount) && path === '/reactive') return null
      // 如果是老用户，则不展示onboarding
      if (!rootState.user.onboardingShow && path === '/onboarding') return null
      // 当用户是beta，且账户过期但没有延长15天，这时用户才能进入/beta-account/extend页面
      if (!(demoType === 'demo' && expiredDemoAccount) && path === '/beta-account/extend') return null
      // 当用户是beta，且延长15天后账户过期，这时用户才能进入/beta-account/reactive页面
      if (!(demoType === 'demo_trail' && expiredTrialAccount) && path === '/beta-account/reactive') return null
      if (demoType === 'demo' && /^\/setting\/subscription-and-billing(-v2)?(\/.*)?$/.test(path)) return null
      if (rootState.user.usersAuthorities['fleet:accounting:accessDriverSettlement'] === 'false' && path === '/accounting/driverSettlement') return null
      if (rootState.user.usersAuthorities['fleet:accounting:accessIFTA'] === 'false' && path === '/accounting/ifta') return null
      if (rootState.user.usersAuthorities['fleet:accounting:accessInvoice'] === 'false' && path === '/accounting/accountingInvoice') return null
      if (rootState.user.usersAuthorities['fleet:accounting:accessExpense'] === 'false' && path === '/accounting/expense') return null
      if ((rootState.user.usersAuthorities['fleet:companySetting:subscriptionBilling'] === 'false' &&  role ===  'operator' ) && /^\/setting\/subscription-and-billing(-v2)?(\/.*)?$/.test(path)) return null
      if ((rootState.user.usersAuthorities['fleet:business:accessMaintenanceModule'] === 'false' &&  role ===  'operator' && path === '/maintenance') ) return null
      if (rootState.user.paymentVersion !== 1 && path === '/setting/add-loadboard-seats') return null
    }
    if (isFully || hasPermission(role, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, rootState, isFully, path)
        if (tmp.children.filter(item => !item.hidden).length === 0 && tmp.permissionNoShowFlag) {
          return null
        }
      }
      res.push(tmp)
    }
  })
  return res
}

// 修改路由顺序
function modifyRoutingOrder(routes, rootState) {
  let onboardingFlag = rootState.user.onboardingFlag
  let hasViewedPayments = localStorage.getItem(`has_reviewed_payments_${rootState.user.userId}`)
  let hasViewedMaintenance = localStorage.getItem(`has_reviewed_maintenance_${rootState.user.userId}`)
  let hasViewedDashboard = localStorage.getItem(`has_reviewed_dashboard_${rootState.user.userId}`)
  let arr = []
  cloneDeep(routes).forEach(item => {
    if (item.path === '/onboarding' && onboardingFlag) {
      // onboardingFlag为true, 删除子路由mete中的tag
      item.children[0].meta.tag = ''
      arr.push(item)
    } else if (item.path === '/onboarding' && !onboardingFlag) {
      // onboardingFlag为false,则onboarding在第一位
      arr.unshift(item)
    } else if (item.path.startsWith('/payments') && hasViewedPayments === 'YES') {
      item.meta.tag = ''
      arr.push(item)
    } else if (item.path === '/maintenance' && hasViewedMaintenance === 'YES') {
      item.meta.tag = ''
      arr.push(item)
    }else if (item.path === '/dashboardv2' && hasViewedDashboard === 'YES') {
      item.meta.tag = ''
      arr.push(item)
    }
     else {
      arr.push(item)
    }
  })
  return arr
}

export default {
  namespaced: true,
  state: () => ({
    routes: [],
  }),
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.routes = routes
    }
  },
  actions: {
    generateRoutes({ commit, rootState }) {
      return new Promise(resolve => {
          const fullyRoutes = filterAsyncRoutes(asyncRoutes, rootState, true)
          const routes = filterAsyncRoutes(asyncRoutes, rootState, false)
          let allRoute = cloneDeep(constantRoutes.concat(routes))
          let arr = []
          cloneDeep(allRoute).forEach(item => {
            if (item.path === '/') {
              arr.unshift(item)
            } else {
              arr.push(item)
            }
          })
          console.log(arr, routes,  'routes')
          const allRoutes = modifyRoutingOrder(arr, rootState)
          commit('SET_ROUTES', allRoutes)
          resolve({ routes, fullyRoutes })
      })
    },
    addRouterToBar({ commit, rootState}) {
      let routes = asyncRoutes
      const allRoutes = modifyRoutingOrder(cloneDeep(constantRoutes.concat(routes)), rootState)
      let arr = []
      cloneDeep(allRoutes).forEach(item => {
        if (item.path !== '/onboarding') {
          arr.push(item)
        }
      })
      commit('SET_ROUTES', arr)
    },
    updateRoutes({ commit, state, rootState }) {
      commit('SET_ROUTES', modifyRoutingOrder(state.routes, rootState))
    }
  }
};
